module.exports = __webpack_public_path__ + "static/media/xmark.6111317a.svg";